/**
 * DTO for creating a shift request (applying for a shift)
 * Matches backend CreateShiftRequestDto
 */
export interface CreateShiftRequestDto {
  shiftNeedId: string;
  requestedHourlyRate?: number; // Optional: for counter-offers/proposals
  message?: string; // Optional: message to facility
}

/**
 * Response after requesting a shift
 * Matches backend ShiftRequestDto
 */
export interface ShiftRequestResponse {
  id: string;
  shiftNeedId: string;
  contractorId: string;
  contractorName: string;
  /** null when no counter-offer has been made */
  latestCounterOfferRate?: number | null;
  latestCounterOfferBy?: 'contractor' | 'facility' | null;
  latestCounterOfferAt?: string | null;
  latestCounterOfferMessage?: string | null;
  /** true iff status === 'negotiating' */
  isNegotiationActive?: boolean;
  message?: string;
  status: string; // e.g. 'pending', 'negotiating', 'accepted', 'declined', 'withdrawn'
  requestedAt: string; // ISO datetime
  respondedAt?: string;
  responseMessage?: string;
}
